import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCqOtm1ET_w09waT9GywUxrsgGyW8HxzB4",
  authDomain: "madad-center.firebaseapp.com",
  projectId: "madad-center",
  messagingSenderId: "453420081508",
  appId: "1:453420081508:web:c977a570f23f7c1b10da71",
  measurementId: "G-F1JF0478WR",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);